/**
 * A helper for returning the keys of an enum
 */
export function enumKeys<O extends object, K extends keyof O = keyof O>(obj: O, sorted = false): K[] {
  const keys = Object.keys(obj).filter((k) => Number.isNaN(+k)) as K[];
  if (sorted) {
    keys.sort();
  }
  return keys;
}

/**
 * A helper for returning the values of an enum
 */
export function enumValues<O extends object, K extends keyof O = keyof O>(obj: O, sorted = false): O[K][] {
  const values = enumKeys(obj).map((k) => obj[k]) as O[K][];
  if (sorted) {
    values.sort();
  }
  return values;
}

/**
 * A helper for returning the subset of an enum
 */
export function enumSubset<T>(enumType: T, keys: (keyof T)[]): Partial<T> {
  return keys.reduce((subset, key) => {
    if (enumType[key] !== undefined) {
      subset[key] = enumType[key];
    }
    return subset;
  }, {} as Partial<T>);
}
